






































































































import Vue from "vue";
import Component from "vue-class-component";
import func from "@/ts/FormFunctions";
import ErrorMessages from "@/ts/constants/PermitsErrorMessages";
import fieldData, { CCDD } from "@/ts/FormData";
import builder, { IVueStateCollection } from "@/ts/FormBuilder";
import { ISelectItemVueModel } from "@/ts/models/ISelectItemVueModel";
import { ICCDDApplicationVueModel } from "@/ts/models/ICCDDApplicationVueModel";

@Component({
    props: {
        form: {
            type: Object as () => ICCDDApplicationVueModel
        },
        vueStates: {
            type: Object as () => IVueStateCollection
        },
        isReadOnly: {
            type: Boolean
        }
    }
})
export default class CCDDApplicationAcceptedMaterials extends Vue {
    name: string = "CCDDApplicationAcceptedMaterials";
    title: string = "";
    index: number = NaN;

    errorMsgs = ErrorMessages;

    mounted(): void {
        this.initializeComponent("AcceptedMaterials");

        if (this.$props.form.acceptedMaterials.length === 0) {
            this.$props.form.acceptedMaterials = CCDD.acceptedMaterials;
        } else {
            (this.$props.form.acceptedMaterials as ISelectItemVueModel[]).forEach((am, ix, arr) => {
                if (func.isNullOrEmpty(am.id)) {
                    am.id = fieldData.getNewId();
                }
            });
        }

        this.$watch("isOtherSelected", (n, o) => {
            if (!n) {
                this.$props.form.otherAcceptedMaterialsDescription = null;
            }
        }, { immediate: true });
    }

    private initializeComponent(routeName: string): void {
        this.index = builder.getIndexByVueState(this.$props.vueStates.views, routeName);
        this.title = this.$props.vueStates.views[this.index].name;

        this.$emit("update:title", this.title);
        this.$emit("update:currentIndex", this.index);

        this.$watch("hasErrors", (n, o) => {
            this.$props.vueStates.views[this.index].error = this.hasErrors;
        }, { immediate: true });

        this.$props.vueStates.views[this.index].visited = true;
    }

    get isOtherSelected(): boolean {
        return this.getIsOtherOptionSelected(this.$props.form.acceptedMaterials);
    }

    get isMaterialsError(): boolean {
        return !(this.$props.form.acceptedMaterials as ISelectItemVueModel[]).some(value => value.isSelected);
    }

    get isOtherDescriptionError(): boolean {
        return this.isOtherSelected && func.isNullOrEmpty(this.$props.form.otherAcceptedMaterialsDescription);
    }

    get hasErrors(): boolean {
        return this.isMaterialsError || this.isOtherDescriptionError;
    }

    private getIsOtherOptionSelected(data: ISelectItemVueModel[]): boolean {
        let item = data.find(value => value.name.endsWith("*"));
        if (item === undefined || item === null) return false;
        return item.isSelected;
    }
}
